import { buildLanguageUrl } from "./localeRouting";

const normalizeLanguage = (language) =>
  String(language || "en").trim().toLowerCase().split("-")[0];

/**
 * Path tương đối (cùng ngôn ngữ → client tự thêm tiền tố) hoặc URL tuyệt đối
 * khi trang chỉ tồn tại ở bản tiếng Anh.
 */
export const getStaticRoutePaths = (language) => {
  const isVietnamese = normalizeLanguage(language) === "vi";

  return {
    whatIsQr: "/what-is-qr-code",
    servicePack: isVietnamese || normalizeLanguage(language) === "en" ? "/service-pack" : buildLanguageUrl("en", "/service-pack"),
    contact: "/contact",
    terms: buildLanguageUrl("en", "/term-of-use"),
    privacy: buildLanguageUrl("en", "/privacy-policy")
  };
};
